function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomLink from '../utils/CustomLink';
import { assetPath, translate, translateFieldName } from '../utils/helpers';

var SingleItem = /*#__PURE__*/function (_Component) {
  _inherits(SingleItem, _Component);

  var _super = _createSuper(SingleItem);

  function SingleItem(props) {
    var _this;

    _classCallCheck(this, SingleItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderImage", function (product) {
      return product.product_photos.length > 0 ? "url(".concat(assetPath(product.product_photos[0].photo.thumb.url), ")") : "url()";
    });

    return _this;
  }

  _createClass(SingleItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isShop = _this$props.isShop,
          product = _this$props.product;
      return isShop ? /*#__PURE__*/React.createElement("div", {
        className: "item-card col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 ".concat(product.slug === null ? 'disabled' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "product-box"
      }, /*#__PURE__*/React.createElement(CustomLink, {
        className: "product__overlay",
        insideRouter: false,
        to: product.slug,
        singleItem: true
      }, product.slug !== null ? /*#__PURE__*/React.createElement("span", {
        className: "btn btn_product uppercase"
      }, translate('LEARN MORE!', 'EN SAVOIR PLUS!')) : null), /*#__PURE__*/React.createElement("div", {
        className: "product-box-inner"
      }, /*#__PURE__*/React.createElement(CustomLink, {
        className: "image",
        insideRouter: false,
        to: product.slug,
        singleItem: true
      }, product.product_photos ? /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: this.renderImage(product)
        },
        alt: product[translateFieldName('code')]
      }) : null), /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, /*#__PURE__*/React.createElement("p", {
        className: "product-code-name uppercase main-txt-hover"
      }, product[translateFieldName('code')]), /*#__PURE__*/React.createElement("div", {
        className: "product-description first-uppercase"
      }, product[translateFieldName('name')]))))) : /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-lg-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "product-box"
      }, /*#__PURE__*/React.createElement(CustomLink, {
        className: "product__overlay",
        insideRouter: false,
        to: product.slug,
        singleItem: true
      }, product.slug !== null ? /*#__PURE__*/React.createElement("span", {
        className: "btn btn_product uppercase"
      }, translate('LEARN MORE!', 'EN SAVOIR PLUS!')) : null), /*#__PURE__*/React.createElement("div", {
        className: "product-box-inner"
      }, /*#__PURE__*/React.createElement(CustomLink, {
        className: "image",
        insideRouter: false,
        to: product.slug,
        singleItem: true
      }, product.product_photos ? /*#__PURE__*/React.createElement("img", {
        alt: product[translateFieldName('code')],
        className: "img_responsive_product",
        src: assetPath(product.product_photos[0].photo.thumb.url)
      }) : null), /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, /*#__PURE__*/React.createElement("p", {
        className: "product-code-name uppercase main-txt-hover"
      }, product[translateFieldName('code')]), /*#__PURE__*/React.createElement("div", {
        className: "product-description first-uppercase"
      }, product[translateFieldName('name')])))));
    }
  }]);

  return SingleItem;
}(Component);

SingleItem.propTypes = {
  product: PropTypes.object,
  insideRouter: PropTypes.bool,
  isShop: PropTypes.bool,
  setActiveProduct: PropTypes.func
};
export default SingleItem;